import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const LeftText = styled.div`
  font-size: 13px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
`;
const RightText = styled.div`
  font-size: 13px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
`;
const ToggleButtonWrapper = styled.div`
  &::before {
    position: absolute;
    font-size: 13px;
    top: 0.3rem;
    left: 8px;
    transition: all 0.3s ease-in-out;
  }
  &::after {
    position: absolute;
    font-size: 13px;
    right: 8px;
    top: 0.3rem;
    transition: all 0.3s ease-in-out;
  }
  ${tw`cursor-pointer select-none rounded-full relative`};
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  height: 24px;
  display: inline-block;
  width: inherit;
  vertical-align: bottom;
  margin: 0 5px;
  z-index: 1;
  .dialog-button {
    z-index: 1;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    padding: 3px 8px;
    background-color:#3DCD58;
    color: #FFFFFF;
    min-width: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    min-width: unset;
    border-radius: 20px;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    position: absolute;
    transition: all 0.3s ease-in-out;
    top: 0.2rem;
    left: 4.5px;
  }

  .activatedRight {
    left: 2.5rem;
    background-color: #3DCD58;
  }

  .deactivatedRight {
    left: 2.5rem;
    background-color: grey;
  }

  .deactivatedLeft{
    background-color: grey;
  }

  flex: 1;
  max-width: 65px;
  transition: all 0.3s ease-in-out;
`;

const styles = {
  boxDiv : {
    width: '-webkit-fill-available',
    padding: '10px'
  }
}

const ToggleButton = (props) => {
  const {right, left, selectedToggleChange, activatedDeactivatedSelection, disabled, defaultSelected } = props;
  const [isSelected, setSelected] = useState(defaultSelected? defaultSelected: left);

  
  const toggleBtn = () => {
    if(isSelected == left) setSelected(right)
    else if(isSelected == right) setSelected(left)
  }

  useEffect(() => {
    selectedToggleChange(isSelected)
  }, [isSelected]);

  return (
    <div className='toggleBtnBox' style={styles.boxDiv}>
     <LeftText>{left}</LeftText>
      <ToggleButtonWrapper onClick={() => !disabled? toggleBtn() : ''} style={{cursor: disabled? 'default' : 'pointer'}}>
        {isSelected && !disabled && <div className={`dialog-button ${isSelected == left ? '' :  activatedDeactivatedSelection ? 'deactivatedRight' :'activatedRight'}`}></div>}
        {isSelected && disabled && <div className={`dialog-button ${isSelected == left ? 'deactivatedLeft' :  'deactivatedRight'}`} style={{cursor: 'default'}}></div>}
      </ToggleButtonWrapper>
      <RightText>{right}</RightText>
    </div>
  );
};

export default ToggleButton;